import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Organization } from "@racoon/api";
import { setSelectedCompany, setSelectedCompanyById, clearSelectedCompany } from "../company.slice";
import { RootState } from "../../store";

export function useSelectedCompany() {
  const dispatch = useDispatch();
  const selectedCompanyId = useSelector((s: RootState) => s.company.selectedCompanyId);
  const selectedCompany = useSelector((s: RootState) => s.company.selectedCompany);

  const select = useCallback((org: Organization) => dispatch(setSelectedCompany(org)), [dispatch]);
  const selectById = useCallback((id: number) => dispatch(setSelectedCompanyById(id)), [dispatch]);
  const clear = useCallback(() => dispatch(clearSelectedCompany()), [dispatch]);

  return useMemo(
    () => ({ selectedCompanyId, selectedCompany, select, selectById, clear }),
    [selectedCompanyId, selectedCompany, select, selectById, clear],
  );
}
